import Lock from "@components/icons/Lock"
import { useSliceContext } from "../SliceProvider"
import { zeroAddress } from "viem"
import { ProductCart } from "@src/lib/cart/cartProductTypes"
import { useProductParams } from "@src/lib/useProductParams"
import { cn } from "@/src/lib/utils"

type Props = {
  product: ProductCart
  isFlex?: boolean
}

const DisplayPrice = ({ product, isFlex = true }: Props) => {
  const { checkoutCompleted, theme } = useSliceContext()
  const { extCheckAddress, isAllowed, extCheckSig } = product
  const { accentColor } = theme

  const { displayedPrice, displayedFullPrice, isDiscounted } =
    useProductParams(product)

  const isLocked =
    extCheckSig != "0x" &&
    extCheckSig != "0x00000000" &&
    extCheckAddress != zeroAddress &&
    !isAllowed
  return (
    <div
      className={cn(
        "sl-flex sl-items-center sl-gap-2 sl-text-yellow-500",
        accentColor
      )}
    >
      {!checkoutCompleted && isLocked && (
        <div className="sl-w-4 sl-h-4">
          <Lock className="sl-w-4 sl-h-4 sl-mr-1" isUnlocked={false} />
        </div>
      )}
      <div
        className={`sl-text-sm ${
          isFlex
            ? "sl-flex sl-flex-wrap sl-justify-end sl-gap-x-2"
            : "sl-text-center"
        }`}
      >
        {isLocked ? (
          "Locked"
        ) : !checkoutCompleted && isDiscounted ? (
          <>
            <p className="sl-text-sm sl-text-muted-foreground/60 sl-line-through">
              {displayedFullPrice}
            </p>
            <p
              className={cn(
                "sl-text-sm sl-font-medium sl-text-yellow-500",
                accentColor
              )}
            >
              {displayedPrice}
            </p>
          </>
        ) : (
          <p className="sl-text-sm sl-text-muted-foreground">
            {displayedPrice}
          </p>
        )}
      </div>
    </div>
  )
}

export default DisplayPrice
